import { ComponentConfig } from '../../../config/route-config';
import {
    WelcomeComponent
} from "../../../pages";
import { CliCLoginComponent } from "./CliCLogin"
export const authenticated: ComponentConfig = {
};
export const unauthenticated: ComponentConfig = {
};
export const all: ComponentConfig = {
};
